import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Notification } from '../models/notification';
import { BehaviorSubject, Observable } from 'rxjs';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { mergeMap, switchMap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class NotificationsService implements Resolve<Notification[]> {
  currentMessage = new BehaviorSubject(null);

  $token: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private angularFireMessaging: AngularFireMessaging, private http: HttpClient, private snackbar: MatSnackBar) {
    this.$token.next(localStorage.getItem('FCM_token'));
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.get();
  }

  get() {
    return this.http.get<Notification[]>(`${environment.apiUrl}notifications`, { withCredentials: true });
  }

  markAsRead(notification: Notification) {
    return this.http.post<Notification[]>(`${environment.apiUrl}notifications/${notification.SubscriptionId}/read`, notification, {
      withCredentials: true,
    });
  }

  MarkAnnouncementAsRead(notification: Notification) {
    return this.http.post<Notification[]>(
      `${environment.apiUrl}notifications/announcement/${notification.AnnouncementId}/read`,
      notification,
      {
        withCredentials: true,
      }
    );
  }

  requestPermission() {
    this.angularFireMessaging.requestToken.subscribe(
      token => {
        this.snackbar.open('Push notifications enabled!', 'OK', { duration: 3000 });
        localStorage.setItem('FCM_token', token);
        this.$token.next(token);
        this.saveToken(token).toPromise().then();
      },
      err => {
        console.error('Unable to get permission to notify.', err);
      }
    );
  }

  removePermission() {
    this.angularFireMessaging.getToken.pipe(switchMap(token => this.angularFireMessaging.deleteToken(token))).subscribe(token => {
      localStorage.removeItem('FCM_token');
      this.snackbar.open('Push notifications disabled', 'OK', { duration: 3000 });
      this.$token.next(null);
      this.saveToken('').toPromise().then();
    });
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(payload => {
      console.log('new message received. ', payload);
      this.currentMessage.next(payload);
    });
  }

  saveToken(token: string) {
    return this.http.get(`${environment.apiUrl}notifications/save-token?token=${token}`, { withCredentials: true });
  }
}
